import { TimeCodesStateType } from './types';

import { Pagination, TimeCodesActionType } from 'enums';
import { TimeCodesActionReturnType } from 'state/actions';

const initState: TimeCodesStateType = {
  isLoading: false,
  timeCodes: [],
  page: Pagination.START_PAGE,
};

export const timeCodesReducer = (
  // eslint-disable-next-line default-param-last
  state: TimeCodesStateType = initState,
  action: TimeCodesActionReturnType,
): TimeCodesStateType => {
  switch (action.type) {
    case TimeCodesActionType.SET_TIME_CODES:
      return { ...state, timeCodes: action.timeCodes };
    case TimeCodesActionType.UPDATE_TIME_CODE:
      return {
        ...state,
        timeCodes: state.timeCodes.map(timeCode =>
          timeCode.id === action.timeCode.id ? action.timeCode : timeCode,
        ),
      };
    case TimeCodesActionType.SET_TIME_CODES_AFTER_SCROLL:
      return { ...state, timeCodes: [...state.timeCodes, ...action.timeCodes] };
    case TimeCodesActionType.SET_TIMECODES_LOADING_STATUS:
      return { ...state, isLoading: action.isLoading };
    case TimeCodesActionType.SET_TIME_CODES_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    default:
      return state;
  }
};
